import { Info } from '@phosphor-icons/react';
import NasAdminPanel from './NasAdminPanel';
import { NAS_I18N } from './nasI18n';

// Status tab. For managers this hosts the NAS admin panel (flags, sources,
// pilot activation, jobs). For read-only viewers it shows source availability.
export default function NasArchiveStatus({ meta, roots, onFlagsChanged }) {
  if (meta?.can_manage) {
    return <NasArchiveStatusManage onFlagsChanged={onFlagsChanged} />;
  }
  return (
    <div className="max-w-[820px]" data-testid="nas-status-readonly">
      <p className="text-xs text-zinc-400 mb-3 inline-flex items-center gap-1">
        <Info size={12} /> NASソースの状態（読み取り専用）
      </p>
      {(!roots || roots.length === 0) ? (
        <p className="text-sm text-zinc-400 py-6">{NAS_I18N.not_configured}</p>
      ) : (
        <ul className="space-y-2">
          {roots.map((r) => (
            <li key={r.id} className="rounded-lg border border-zinc-200 bg-white px-3 py-2 text-sm" data-testid={`nas-status-root-${r.id}`}>
              <span className="font-medium text-zinc-800">{r.logical_name}</span>
              <span className="ml-2 text-xs text-zinc-400">取り込み: {r.indexing_status} · ソース: {r.source_status}</span>
              {r.is_test && <span className="ml-2 text-xs text-violet-600">テストソース</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function NasArchiveStatusManage({ onFlagsChanged }) {
  return (
    <div data-testid="nas-status-manage">
      <NasAdminPanel onFlagsChanged={onFlagsChanged} />
    </div>
  );
}
